module.exports = __webpack_public_path__ + "media/images/taxigo-platinum/work2-2a25e2e91c8c3775ebacd186e26562e2.svg";